const DATE_FORMAT = { day: "2-digit", month: "short", year: "numeric" };

export const getPlanDates = (planValidity) => {
  const currentDate = new Date().toLocaleDateString("en-GB", DATE_FORMAT);
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + Number(planValidity) * 30);
  const formattedEndDate = endDate.toLocaleDateString("en-GB", DATE_FORMAT);
  return { currentDate, formattedEndDate };
};

export const getCoverageByPlan = (planDescription) => {
  if (!planDescription) return "5,000";
  const match = planDescription.match(/(\d+)K/i);
  if (match) return `${Number(match[1])},000`;
  return "5,000";
};
